export default {
    auth: {
        login: {
            buttons: {
                enter: 'Tham gia',
                otherStudent: 'Tham gia với tư cách học sinh khác',
                otherClassroom: 'Tham gia lớp học khác',
                pwa: 'Tạo lối tắt',
            },
            pwa: {
                title: 'Bạn muốn tạo lối tắt trên màn hình chính như ứng dụng không?',
                description: 'Từ nay, bạn có thể tham gia trực tiếp mà không cần mã lớp học!',
                install: {
                    ios: 'Nhấn nút "Chia sẻ" ở dưới cùng trình duyệt Safari, sau đó chọn "Thêm vào màn hình chính".',
                    android: 'Nhấn menu trình duyệt (⋮), sau đó chọn "Cài đặt ứng dụng".',
                    default: 'Chọn "Thêm vào màn hình chính" hoặc "Cài đặt ứng dụng" trong menu trình duyệt.',
                },
                buttons: {
                    next: 'Tôi sẽ làm sau',
                    create: 'Tạo lối tắt',
                },
            },
            pinSet: 'Mã PIN đã được thiết lập! Vui lòng tham gia buổi học.',
            stepClassroom: {
                title: 'Học sinh tham gia',
                description: 'Vui lòng nhập mã lớp học mà giáo viên đã chia sẻ!',
            },
            stepPin: {
                studentInfo: 'Số {number} {name}',
                input: 'Vui lòng nhập mã PIN để tham gia buổi học.',
                set: 'Vui lòng thiết lập mã PIN để tham gia buổi học.',
                retry: 'Vui lòng nhập lại mã PIN.',
                tip: 'Đừng quên mã PIN vì bạn sẽ cần mã này để tham gia buổi học!',
                error: {
                    confirm: 'Mã PIN không khớp! Hãy kiểm tra lại và nhập lại.',
                    unknown: 'Đã xảy ra lỗi không xác định.',
                    pin: 'Không thể xác minh mã PIN.',
                    set: 'Không thể thiết lập mã PIN.',
                },
            },
            stepStudent: {
                title: 'Hãy nhập số thứ tự và tên của bạn!',
                placeholder: {
                    number: 'Nhập số thứ tự (chỉ số)',
                    name: 'Nhập tên của bạn (chỉ tiếng Hàn)',
                },
                error: {
                    nameKorean: 'Chỉ được nhập chữ Hàn.',
                    number: 'Chỉ có thể nhập số.',
                    unknown: 'Đã xảy ra lỗi không xác định.',
                },
            },
        },
    },
};
